import { string, collection } from '@gogame/schemas';

import { ID } from 'scenes/KPI/components/KPIForm/constants';
import { kpiSeriesSchema } from 'scenes/KPI/components/KPIForm/schemas';

export const seriesSchema = collection(
  kpiSeriesSchema.shape({
    [ID]: string(),
  })
).default([]);
